<template>
  <!-- Trusted Brands Section - Modern Premium Design -->
  <section class="brands-section">
    <!-- Background Decorative Elements -->
    <div class="brands-section__bg">
      <div class="brands-section__bg-gradient"></div>
      <div class="brands-section__bg-pattern"></div>
    </div>

    <div class="brands-container">
      <!-- Section Header -->
      <div class="brands-header">
        <div class="brands-header__accent"></div>
        <span class="brands-header__badge">
          <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
          </svg>
          {{ $t('home.brands.trustBadge') }}
        </span>
        <h2 class="brands-header__title">{{ $t('home.brands.title') }}</h2>
        <p class="brands-header__subtitle">{{ $t('home.brands.subtitle') }}</p>
      </div>

      <!-- Brands Marquee -->
      <div class="brands-showcase">
        <div class="brands-marquee">
          <div class="brands-marquee__track">
            <!-- First set -->
            <div class="brands-marquee__item">
              <img src="/images/Brands/idc0fO79Qg.jpeg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0002.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0004.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0005.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0006.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0007.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/muller-martini.png" alt="Muller Martini" loading="lazy" />
            </div>
            <!-- Duplicate for seamless loop -->
            <div class="brands-marquee__item">
              <img src="/images/Brands/idc0fO79Qg.jpeg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0002.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0004.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0005.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0006.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/IMG-20250911-WA0007.jpg" alt="Brand Partner" loading="lazy" />
            </div>
            <div class="brands-marquee__item">
              <img src="/images/Brands/muller-martini.png" alt="Muller Martini" loading="lazy" />
            </div>
          </div>
        </div>
        
        <!-- Fade Edges -->
        <div class="brands-showcase__fade brands-showcase__fade--left"></div>
        <div class="brands-showcase__fade brands-showcase__fade--right"></div>
      </div>
    </div>
  </section>
</template>

<script setup>
</script>

<style scoped>
/* Section Layout */
.brands-section {
  position: relative;
  padding: 80px 0;
  overflow: hidden;
  background: linear-gradient(180deg, #f1f5f9 0%, #f8fafc 50%, #ffffff 100%);
}

.brands-section__bg {
  display: none;
}

.brands-section__bg-gradient {
  display: none;
}

.brands-section__bg-pattern {
  display: none;
}

.brands-container {
  position: relative;
  z-index: 1;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Styles */
.brands-header {
  text-align: left;
  margin-bottom: 56px;
  max-width: 600px;
}

.brands-header__accent {
  width: 48px;
  height: 4px;
  background: linear-gradient(90deg, #2563eb 0%, #1d4ed8 100%);
  border-radius: 2px;
  margin-bottom: 16px;
}

.brands-header__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1d4ed8;
  font-size: 13px;
  font-weight: 600;
  border-radius: 20px;
  margin-bottom: 16px;
  letter-spacing: 0.02em;
}

.brands-header__title {
  font-size: 36px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 12px 0;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.brands-header__subtitle {
  font-size: 18px;
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

/* Brands Showcase */
.brands-showcase {
  position: relative;
  margin-bottom: 56px;
}

.brands-marquee {
  overflow: hidden;
  padding: 32px 0;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.brands-marquee__track {
  display: flex;
  gap: 56px;
  animation: marquee 35s linear infinite;
  width: fit-content;
}

.brands-marquee:hover .brands-marquee__track {
  animation-play-state: paused;
}

.brands-marquee__item {
  flex-shrink: 0;
  width: 160px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.brands-marquee__item:hover {
  background: #ffffff;
  border-color: rgba(59, 130, 246, 0.3);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.brands-marquee__item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  filter: grayscale(30%);
  opacity: 0.85;
  transition: all 0.4s ease;
}

.brands-marquee__item:hover img {
  opacity: 1;
  filter: grayscale(0%);
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* Fade Edges */
.brands-showcase__fade {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100px;
  z-index: 2;
  pointer-events: none;
}

.brands-showcase__fade--left {
  left: 0;
  background: linear-gradient(90deg, #f8fafc 0%, transparent 100%);
}

.brands-showcase__fade--right {
  right: 0;
  background: linear-gradient(-90deg, #f8fafc 0%, transparent 100%);
}

/* Responsive */
@media (max-width: 768px) {
  .brands-section {
    padding: 60px 0;
  }

  .brands-header__title {
    font-size: 30px;
  }

  .brands-header__subtitle {
    font-size: 16px;
  }

  .brands-marquee__item {
    width: 120px;
    height: 60px;
    border-radius: 6px;
  }

  .brands-marquee__track {
    gap: 32px;
  }

  .brands-showcase__fade {
    width: 60px;
  }
}
</style>
